import React from 'react';
import { Box, Divider } from '@mui/material';
import { CFDForm } from './CFDForm';
import { APPForm } from './APPForm';
import { ConfigFileManager } from './ConfigFileManager';
import { CustomTypography } from 'shared/ui/CustomTypography';

const subtitleContainerSx = {
  position: 'sticky', // Make the entire container sticky
  top: 0, // Stick to the top
  zIndex: 10, // Ensure it appears above other content
  width: '100%',
  backgroundColor: '#1e1e1e'
};

export const OptimizationPanel: React.FC = () => {
  return (
    <Box component="div" sx={{ height: '100%', width: '100%' }}>

      {/* Sticky container for subtitle and divider */}
      <Box component="div" sx={subtitleContainerSx}>
        <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
          <CustomTypography >Optimization Setup</CustomTypography>
        </Box>

        <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

        <ConfigFileManager />
      </Box>

      {/* Scrollable content below */}
      <Box component="div" sx={{ width: '100%', paddingBottom: 0.5 }}>
        <CFDForm subtitle={"CFD Setup"} />
      </Box>
      <Box component="div" sx={{ width: '100%' }}>
        <APPForm subtitle={"Application Setup"} />
      </Box>
    </Box>
  );
};
